<template>
  <section>
    <div class="card-band-styling">
      <h3>Login</h3>
      <div>
        <div>Email Address</div>
        <div>
          <input type="email" v-model="inputObjectLogin.email" />
        </div>
        <div id="errorEmail-login" class="warning-alert">
        </div>
      </div>
      <div>
        <div>Password</div>
        <div>
          <input v-if="passwordShow1 == false" type="password" v-model="inputObjectLogin.password" />
          <input v-if="passwordShow1" type="text" v-model="inputObjectLogin.password" />
          <b-icon-eye-fill v-if="passwordShow1 == false" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('1')"></b-icon-eye-fill>
          <b-icon-eye-slash-fill v-if="passwordShow1" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('1')"></b-icon-eye-slash-fill>
          <div id="forgot-password-container">
            <router-link to="/forgot-password">
              Forgot Password
            </router-link>
          </div>
          <small>
            <b-form-text>
              Password must contain at least 8 characters, 1 number, and
              1 special character (e.g. '$', '%', '@')
            </b-form-text>
          </small>
        </div>
        <div id="errorPassword-login" class="warning-alert">
        </div>
      </div>
      <div id="message-login" class="warning-alert">
      </div>
      <div class="button-container">
        <button @click="submit">
          <b-spinner small v-if="loadingLogin"></b-spinner>
          <span v-if="loadingLogin">Logging in</span><span v-else>Login</span>
        </button>
      </div>
    </div>
  </section>

</template>

<style scoped lang="scss">
  @use 'sharedSCSS/globalSharedVariables';

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Roboto', sans-serif;
  }

  input {
    width: 100%;
  }

  .card-band-styling {
    width: 75%;
  }

  .warning-alert {
    background-color: #ED7878;
    border-radius: 5px;
    margin: 5px 0;
  }

  .confirmation-alert {
    background-color: #6BFF6B;
    border-radius: 5px;
    margin: 5px 0;
  }

  h3 {
    text-align: center;
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #forgot-password-container {
    display: flex;
    justify-content: flex-end;
    font-size: .8rem;
  }
</style>

<script>
import instance from "../axios.js";
import { BIconEyeFill, BIconEyeSlashFill } from "bootstrap-vue";

export default {
  components: {
    BIconEyeFill,
    BIconEyeSlashFill,
  },
  name: "loginPage",

  data() {
    return {
      inputObjectLogin: {
        email: '',
        password: ''
      },
      passwordShow1: false,
      errors: {},
      loadingLogin: false
    };
  },
  methods: {
    togglePassword(number) {
      if (number == "1") {
        this.passwordShow1 = !this.passwordShow1;
      }
      if (number == "2") {
        this.passwordShow2 = !this.passwordShow2;
      }
      if (number == "3") {
        this.passwordShow3 = !this.passwordShow3;
      }
    },
    validateEmail(email) {
      if (!email.length || email.length == 0) {
        return { valid: false, error: "This field is required" };
      }
      if (email.match(/^\w+([.-]?\w+)_@\w+(_[_.-]?\w+)_(.\w{2,3})+$/)) {
        return {
          valid: false,
          error: "Please enter a valid email.",
        };
      }
      return { valid: true, error: null };
    },
    validatePassword(password) {
      if (!password.length || password.length == 0) {
        return { valid: false, error: "This field is required" };
      }
      if (password.length < 8) {
        return {
          valid: false,
          error: "Password requires at least 8 characters",
        };
      }
      if (
        !/[~`!#$@%&*+=\-';,/{}|":<>]/g.test(password) ||
        !/\d/.test(password)
      ) {
        return {
          valid: false,
          error:
            "Password requires at least 1 number and 1 special character (e.g. '$', '%', '@').",
        };
      }
      return { valid: true, error: null };
    },
    submit() {
      let valid = true;
      this.errors = {};
      document.getElementById('errorEmail-login').innerText = '';
      document.getElementById('errorPassword-login').innerText = '';
      document.getElementById('message-login').innerText = '';

      let email = this.inputObjectLogin.email;
      let password = this.inputObjectLogin.password;

      const validEmail = this.validateEmail(email);
      if (!validEmail.valid) {
        valid = false;
        document.getElementById('errorEmail-login').innerText = validEmail.error;
      }

      const validPassword = this.validatePassword(password);
      if (!validPassword.valid) {
        valid = false;
        document.getElementById('errorPassword-login').innerText = validPassword.error;
      }

      if (valid) {
        this.loadingLogin = true;
        let dataToSubmit = {
          id: "",
          email: email,
          password: password,
          pending: "",
          pending_token: '',
        };

        instance.post("/api/auth/login", dataToSubmit)
          .then((response) => {
            if (response.data.userId != "") {
              if (response.data.message == "pending") {
                document.getElementById('message-login').innerText = "This account is still pending approval. Please wait for your account to be approved. You will receive an account status email within 5-7 business days.";
                this.loadingLogin = false;
              } else {
                this.$store.commit("setAuthUser", response.data.userId);
                this.$store.commit("setCurrentEmail", response.data.email);
                this.$store.commit("setUserLevel", response.data.accessRole);
                this.loadingLogin = false;
                this.$router.push("/");
              }
            }
          })
          .catch((error) => {
            document.getElementById('message-login').innerText = "The provided email or password is incorrect.";
            this.loadingLogin = false;
            console.log(error);
          });
      }
    },
  },
};
</script>
